import React from 'react'

import SkeletonLoader from '../index'
import BubbleLoader from '../../../components/common/BubbleLoader'

export default function SpinnerLoader ({
  position = 'absolute',
  withBackdrop = true,
  isLoading = false,
  style = {},
  className,
  children
}) {
  const _className = [
    'spinner-loader',
    withBackdrop ? 'with-backdrop' : null,
    className
  ]
  .filter(name => name)
  .join(' ')

  return (
    <SkeletonLoader
      isLoading={isLoading}
    >
      <SkeletonLoader.Skeleton>
        <div
          className={_className}
          style={{ position, ...style }}
        >
          <BubbleLoader />
        </div>
      </SkeletonLoader.Skeleton>
      { children }
    </SkeletonLoader>
  )
}